<template>
  <div id="quickIndemnity">
    <div class="yto-box search-form y-pb-0">
      <el-form
        ref="searchForm"
        :inline="true"
        :model="form"
        label-width="100px"
      >
      <el-row>
        <el-form-item prop="createTime" label-width="0" class="time-style">
          <el-select v-model="form.timeType" placeholder="活动区域" class="timetype-style">
            <el-option label="发起时间" value="createTime"></el-option>
            <el-option label="打款时间" value="remitTime"></el-option>
          </el-select>
          <yto-date-picker
            :maxRangeVal="31"
            class="date-style"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            v-model="form.createTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
          ></yto-date-picker>
        </el-form-item>
        <el-form-item prop="indemnityType" label="理赔类型">
          <el-select v-model="form.indemnityType" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in indemnityTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号" prop="waybillNo">
          <el-input v-model="form.waybillNo" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="店铺名称" prop="mallCode">
          <el-select v-model="form.mallCode" filterable placeholder="请选择" clearable>
            <el-option
              v-for="item in mallList"
              :key="item.mallCode"
              :label="item.mallName"
              :value="item.mallCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流水号" prop="remitSerialNo">
          <el-input v-model="form.remitSerialNo" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item prop="quickPayType" label="收款对象">
          <el-select v-model="form.quickPayType" placeholder="请选择">
            <el-option
              v-for="item in quickPayTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item  style="float:right; margin-right:0">
          <div class="button-group">
            <el-button type="primary" @click="pageChange(1)" icon="el-icon-search">查询</el-button>
            <el-button class="normal-btn" @click="resetForm('searchForm')"><i class="el-icon-refresh-left y-fc-4C84FF"></i>重置</el-button>
            <el-button @click="exportFile" :loading="exportLoading" :disabled="tableLoading || total === 0"><i class="el-icon-download y-fc-4C84FF"></i>导出</el-button>
          </div>
        </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div class="yto-box y-pb-0">
      <div class="y-mb-20 y-t-al y-f y-f-a">
        <el-button class="normal-btn setting-btn" @click="openCollecAccount"><img src="@/assets/images/icon_shoukuanzhanghu.png"/>设置店铺收款账号</el-button>
        <!-- <el-button class="normal-btn setting-btn" @click="openRealName"><img src="@/assets/images/icon_shoukuanzhanghu.png"/>设置店铺收款账号</el-button> -->
        <el-alert class="y-d-ib alert-style" show-icon :closable="false">
          <span>店铺收款账号设置后，产生的快速理赔款将直接打款至店铺对应的支付宝账号中</span>
        </el-alert>
      </div>
      <div class="yto-table">
        <el-table :data="tableData" style="width: 100%" v-loading='tableLoading'>
          <el-table-column prop="waybillNo" label="运单号"  align="center"  min-width="130px">
            <template slot-scope="scope">
              <span class="hilightColor" @click="showWaybillDetail(scope.row)">{{scope.row.waybillNo}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mallName" label="店铺名称" align="center" min-width="150px">
            <template slot-scope="scope">
              <div class="y-f y-f-jc y-f-as" v-for="(item,index) in scope.row.mallInfos" :key="index">
                <svg-icon :iconClass="PLATFORMICONMAP[item.platformCode]" class="custom-table-list-svg y-mr-5 y-f-shrink"></svg-icon>
                <span class="y-fl-18">{{item.mallName}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="platform" label="平台" align="center" min-width="80px">
            <template slot-scope="scope">
              <div class="y-f y-f-jc y-f-a" v-for="(item,index) in scope.row.mallInfos" :key="index">
                <span class="y-fl-18">{{ PLATFORMNAMEMAP[item.platformCode] }}</span>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="indemnityType" label="理赔类型"  align="center" min-width="80px">
            <template  slot-scope="scope">
              <span v-for="item in indemnityTypeList" :key="item.code">
                <template v-if="item.code == scope.row.indemnityType">{{item.name}}</template>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="indemnityGoodsWorth" label="物品价值(元)" align="center" min-width="90px"></el-table-column>
          <el-table-column prop="indemnityAmount" label="理赔金额(元)" align="center" min-width="90px"></el-table-column>
          <el-table-column prop="createTime" label="理赔发起时间" align="center" min-width="150px"></el-table-column>
          <el-table-column prop="remitAmount" label="赔付金额(元)" align="center" min-width="90px"></el-table-column>
          <el-table-column prop="remitStatus" label="打款状态" align="center" min-width="100px">
            <template slot-scope="scope">
              <div class="y-f y-f-jc">
                <!-- quickPayFlag--是否秒赔；true代表是 -->
                <div class="y-w-70 y-f y-f-a">
                  <span>{{ scope.row.remitStatus }}</span>
                  <img class="y-w-25 y-h-25" src="@/assets/images/message/icon_shot@2x.png" v-if="scope.row.quickPayFlag">
                  <div class="y-w-25" v-else></div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="收款对象" align="center" min-width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.quickPayType==1">发件网点</span>
              <span v-if="scope.row.quickPayType==2">商家支付宝</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="remitAccount" label="收款账号" align="center" min-width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.quickPayType==1">-</span>
              <div class="y-f y-f-jc y-f-a" v-else>
                <span >{{scope.row.remitAccount}}</span>
                <el-popover
                  width="100"
                  trigger="click"
                  :content="nerRemitAccount">
                  <img slot="reference" src="@/assets/images/view-blue.png" class="view-img-style" @click.prevent.stop="viewRemitAccount(scope.row)"/>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remitSerialNo" label="打款流水号" align="center" min-width="150px">
            <template slot-scope="scope">
              <span v-if="scope.row.quickPayType==1">-</span>
              <span w-else>{{scope.row.remitSerialNo}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remitTime" label="打款时间" align="center" min-width="150px"></el-table-column>
          <el-table-column prop="indemnityType" label="操作"  align="center" min-width="80px">
            <template  slot-scope="scope">
              <span v-if="scope.row.quickPayType==1">-</span>
              <div v-else>
                <span v-if="scope.row.alipaySerialNo" class="y-fc-4C84FF y-c-p" @click="dowloadEleImage(scope.row)">电子回单下载</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="limitChange"
          @current-change="pageChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 走件详情 -->
    <orderTrackingDetails
      :value="showDialog"
      v-if="showDialog"
      :data="orderDetailsData"
      @close="closeDetailInfo"
      ref="orderTrackingDetails"
    ></orderTrackingDetails>
    <!-- 设置店铺收款账号 -->
    <set-collect-account
      :value="collecAccountDialog"
      v-if="collecAccountDialog"
      :data="collecAccountData"
      @close="closeCollecAccount"
      ref="setCollecAccount"
    ></set-collect-account>
    <!-- 支付宝已授权请填写支付宝账号对应的姓名 -->
    <real-name
      :value="realNameDialog"
      v-if="realNameDialog"
      :data="realNameData"
      @close="closeRealName"
      ref="realName"></real-name>
  </div>
</template>

<script>
import { YTOSHORTCUTSDAY, dateFormat, downloadFile } from '@/utils/util';
import { PLATFORMNAMEMAP, PLATFORMICONMAP } from '@/utils/globalConfig';
import { queryQuickIndemnityListApi, exportQuickIndemnityListApi, getIndemnityTypeApi, getMallsOfUserByQuickIndemnityApi, queryDecrypByQuickIndemnitytApi, getDownloadBillReceiptApi } from '../../api/quickIndemnity/quickIndemnity';
import { getAllMallsOfUserApi } from '../../api/quickIndemnity/quicksettlement';
import SetCollectAccount from './setCollectAccountByQuick/setCollectAccount.vue';
import RealName from './setCollectAccountByQuick/realName.vue';
export default {
  components: {
    SetCollectAccount,
    RealName
  },
  name: 'quickIndemnity',
  mixins: [],
  props:{
    realNameInfo:{
      type: Object,
      default:{}
    },
  },
  data() {
    return {
      PLATFORMICONMAP,
      PLATFORMNAMEMAP,
      pickerOptions: {
        ...YTOSHORTCUTSDAY,
        disabledDate(time) {
          return (
            time.getTime() > new Date(`${dateFormat(new Date(), 'yyyy-MM-dd')}`).getTime()
          );
        }
      },
      mallList: [],// 店铺下拉列表
      indemnityTypeList: [],// 理赔类型下拉列表
      quickPayTypeList: [
        { label: '全部', value: '' },
        { label: '发件网点', value: '1' },
        { label: '商家支付宝', value: '2' },
      ],// 收款对象下拉列表
      form: {
        timeType: 'createTime',
        createTime: [],
        indemnityType: '',
        quickPayType: '',
        waybillNo: '',
        mallCode: '',
        remitSerialNo: ''
      },
      nerRemitAccount:'',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showDialog: false, // 走件物流轨迹
      orderDetailsData: {}, // 走件物流轨迹dialog入参
      tableLoading: false,
      exportLoading: false,

      collecAccountDialog: false, // 设置理赔账户
      collecAccountData: {},

      realNameDialog: false, // 设置支付宝真实姓名
      realNameData: {},
    };
  },
  created() {
    this.queryMallList();
    this.getIndemnityType();
    let yesterday = new Date(new Date().getTime() - 30 * 24 * 3600000);
    let createTime = [];
    createTime = [
      `${dateFormat(yesterday, 'yyyy-MM-dd')}`,
      `${dateFormat(new Date(), 'yyyy-MM-dd')}`
    ];
    this.$set(this.form, 'createTime', createTime);
  },
  mounted() {
    if(this.$route.query && this.$route.query.activeName && this.$route.query.activeName == 'quickIndemnity'){
      if(this.$route.query.createTime){
        let createTime = [this.$route.query.createTime,this.$route.query.createTime];
        this.$set(this.form, 'createTime', createTime);
      }
      if(this.$route.query.remitSerialNo){
        this.$set(this.form, 'remitSerialNo', this.$route.query.remitSerialNo)
      }
    }
    this.pageChange(1);
  },
  methods: {
    // 下载电子回单
    dowloadEleImage(row) {
      getDownloadBillReceiptApi(row.alipaySerialNo).then(res => {
        if (res.status == 0 && res.data) {
          window.open(res.data, true);
        } else {
          this.$message({
            message: '您的电子回单支付宝暂未生成，请稍后再试',
            type: 'error',
            duration: 3000
          });
        }
      }).catch(err=> {
        this.$message.error(err.message || '网络异常，请稍候重试')
      })
    },
    viewRemitAccount(row){
      let params = {
        remitSerialNo: row.remitSerialNo
      }
      queryDecrypByQuickIndemnitytApi(params).then(res => {
      console.log(res)
        if (res.status==0 && res.data) {
          this.nerRemitAccount = res.data.remitAccount || '';
        } else {
          this.nerRemitAccount = '';
        }
      }).catch((err) => {
         this.nerRemitAccount = '';
        console.log(err);
      });
    },
     // 打开设置理赔账户窗口
    openCollecAccount() {
      let mallList = [];
      //获取指定用户的所有授权有效非分享店铺列表
      getAllMallsOfUserApi().then(res => {
        console.log(res)
          if (res.status==200 && res.data) {
            mallList = res.data || [];
          } else {
            mallList = [];
          }
        }).catch((err) => {
          mallList = [];
          console.log(err);
        }).finally(() => {
          if(mallList && mallList.length>0){
              this.collecAccountDialog = true;
              this.collecAccountData = {
                title: '店铺收款账号设置',
                mallList: mallList
              };
            }else{
              this.$alert('您的当前账号暂无授权店铺，请先进行店铺授权', '提示', {
                confirmButtonText: '去授权',
                type: 'warning'
              }).then(() => {
                this.$router.push({
                  path: '/systemSetting/storeManagement',
                  query: {}
                })
              }).catch(() => {});
            }
        });


      
    },
    // 关闭设置理赔账户窗口
    closeCollecAccount() {
      this.collecAccountDialog = false;
      this.currentPage = 1;
      // this.queryIssue();
    },
    openRealName() {
      this.realNameDialog = true;
      this.realNameData = JSON.parse(JSON.stringify(this.realNameInfo));
    },
    closeRealName() {
      this.realNameDialog = false;
      // this.realNameData = {};
    },


    // 快速理赔--店铺列表查询
    queryMallList() {
      getMallsOfUserByQuickIndemnityApi().then(res => {
        if (res.status==0) {
          if (res.data && res.data.length) {
            this.mallList = res.data || [];
          } else {
            this.mallList = [];
          }
        } else {
          this.mallList = [];
        }
      }).catch((err) => {
         this.mallList = [];
        console.log(err);
      });
    },
    // 快速理赔--理赔类型查询
    getIndemnityType() {
      getIndemnityTypeApi().then(res => {
        if (res.status==0) {
          if (res.data && res.data.length) {
            this.indemnityTypeList = res.data || [];
          } else {
            this.indemnityTypeList = [];
          }
        } else {
          this.indemnityTypeList = [];
        }
      }).catch((err) => {
         this.indemnityTypeList = [];
        console.log(err);
      });
    },
    // 显示运单号走件物流轨迹窗口
    showWaybillDetail(row) {
      this.showDialog = true;
      this.orderDetailsData = {
        code: row.waybillNo, // 订单号
        title: '走件详情', // dialog头部标题
        isComplaint: false, // 是否为客户投诉模块
        notShowStartOrder: true // 是否不展示一键工单按钮
      };
    },
    // 关闭运单号走件物流轨迹窗口
    closeDetailInfo() {
      this.showDialog = false;
    },
    // 每页条数改变
    limitChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryList();
    },
    // 页码改变
    pageChange(val) {
      this.currentPage = val;
      this.queryList();
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.timeType = 'createTime';
      this.$nextTick(()=>{
        this.pageChange(1);
      })
    },
    // 列表查询
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        timeType: this.form.timeType,
        startTime: this.form.createTime[0]+' 00:00:00',
        endTime: this.form.createTime[1]+' 23:59:59',
        indemnityType: this.form.indemnityType,
        quickPayType: this.form.quickPayType,
        waybillNo: this.form.waybillNo,
        mallCode: this.form.mallCode,
        remitSerialNo: this.form.remitSerialNo
      };
      this.tableLoading = true;
      queryQuickIndemnityListApi(params).then(res => {
        this.tableLoading = false;
        if(res.status==0){
          if(res.data && res.data.list && res.data.list.length){
            this.tableData = res.data.list || [];
            this.total = res.data.total || 0;
          }else{
            this.tableData = [];
            this.total = 0;
          }
        }else{
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.tableLoading = false;
        this.tableData = [];
        this.total = 0;
      });
    },
    // 导出
    exportFile() {
      let params = {
        timeType: this.form.timeType,
        startTime: this.form.createTime[0]+' 00:00:00',
        endTime: this.form.createTime[1]+' 23:59:59',
        indemnityType: this.form.indemnityType,
        quickPayType: this.form.quickPayType,
        waybillNo: this.form.waybillNo,
        mallCode: this.form.mallCode,
        remitSerialNo: this.form.remitSerialNo
      };
      this.exportLoading = true;
      if (this.total === 0) {
        this.exportLoading = false;
        this.$message.error('当前无数据可导出!');
      } else {
        exportQuickIndemnityListApi(params).then(res => {
          this.exportLoading = false;
          let blob = new Blob([res]);
          let fileName = '客户管家快速理赔导出.xls';
          downloadFile(blob, fileName);
        }).finally(() => {
          this.exportLoading = false;
        });
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../styles/variables';
.hilightColor {
  color: $blue-style;
  cursor: pointer;
}
#quickIndemnity{
  background-color: #F0F2F8;
  .search-form{
    .el-form-item{
      margin-right: 0;
    }
    /deep/.el-form-item__label{
      padding-right: 8px;
    }
    .timetype-style{
      width: 100px;
    }
    .date-style{
      width: 250px;
      padding: 3px 5px;
    }
  }
  .setting-btn{
    img{
      width: 14px;
      vertical-align: text-bottom;
      margin-right: 4px;
    }
  }
  .alert-style{
    margin-left: 10px;
    display: inline-flex;
    padding: 0px 10px;
    line-height: 34px;
    height: 34px;
    width: 500px;
  }
  .helpInfo{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }
  .view-img-style{
    width: 16px;
    height: 16px;
    margin-left: 10px;
    display: inline-block;
    cursor: pointer;
  }
}
.tooltip-style{
  width: 1000px;
}
/deep/.el-form-item{
  .el-form-item__label{
    padding-right: 5px;
  }
}
</style>
